"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSmsModule = exports.isIceeSensorModule = exports.isIsenseSensorModule = exports.isECWBlackbox = exports.isECWSensor = exports.isECPDummy = exports.isECPSensor = exports.isSmartPlasticsType = exports.isSmartPlasticsPartModel = exports.SmartPlasticsPartModelSchema = void 0;
const tslib_1 = require("tslib");
const echain_shared_i18n_1 = require("@igus/echain-shared-i18n");
const zod_1 = require("zod");
const ArticleType_1 = require("../ArticleType");
const SmartPlasticsPartSchema_1 = tslib_1.__importDefault(require("../../generated/zod/modelSchema/SmartPlasticsPartSchema"));
const echain_prisma_client_1 = require("@igus/echain-prisma-client");
const echain_shared_ts_utils_1 = require("@igus/echain-shared-ts-utils");
exports.SmartPlasticsPartModelSchema = SmartPlasticsPartSchema_1.default.extend({
    articleType: zod_1.z.custom((a) => a === ArticleType_1.ArticleType.zubehoer, { message: 'invalid ArticleType' }),
    // JSON fields => LocalizedText's
    artNr: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    description: zod_1.z.custom(echain_shared_i18n_1.isLocalizedText, { message: 'invalid LocalizedText' }),
    akeneoUuid: zod_1.z
        .string()
        .nullish()
        .transform((x) => x !== null && x !== void 0 ? x : undefined)
        .optional(),
    interiorDrawingProperties: zod_1.z
        .object({
        iaBodenH_mm: zod_1.z.number().optional(),
        iaHKBOT_mm: zod_1.z.number().optional(),
        iaHKB_mm: zod_1.z.number().optional(),
        iaHKDist_mm: zod_1.z.number().optional(),
        iaHKH_mm: zod_1.z.number().optional(),
        iaHKHeight_mm: zod_1.z.number().optional(),
        iaHKOLB_mm: zod_1.z.number().optional(),
        iaHKOLOB_mm: zod_1.z.number().optional(),
        iaHKOLOH_mm: zod_1.z.number().optional(),
        iaHKOLUB_mm: zod_1.z.number().optional(),
        iaHKOLUH_Rounded: zod_1.z.boolean().optional(),
        iaHKOLUH_mm: zod_1.z.number().optional(),
        iaHKORB_mm: zod_1.z.number().optional(),
        iaHKOROB_mm: zod_1.z.number().optional(),
        iaHKORUB_mm: zod_1.z.number().optional(),
        iaHKRep: zod_1.z.number().optional(),
        iaHKULB_mm: zod_1.z.number().optional(),
        iaHKULOB_mm: zod_1.z.number().optional(),
        iaHKULOH_Rounded: zod_1.z.boolean().optional(),
        iaHKULOH_mm: zod_1.z.number().optional(),
        iaHKULUB_mm: zod_1.z.number().optional(),
        iaHKULUH_mm: zod_1.z.number().optional(),
        iaHKURB_mm: zod_1.z.number().optional(),
        iaHKUROB_mm: zod_1.z.number().optional(),
        iaHKURUB_mm: zod_1.z.number().optional(),
        iaKisteHO_mm: zod_1.z.number().optional(),
        iaKisteHU_mm: zod_1.z.number().optional(),
        iaUebermass_mm: zod_1.z.number().optional(),
        iawmm_mm: zod_1.z.number().optional(),
        iaArtikeltyp: zod_1.z.number().optional(),
    })
        .nullish()
        .transform((x) => (x && Object.keys(x).length ? x : undefined))
        .optional(),
});
const isSmartPlasticsPartModel = (whatever) => {
    var _a;
    return (_a = exports.SmartPlasticsPartModelSchema.safeParse(whatever)) === null || _a === void 0 ? void 0 : _a.success;
};
exports.isSmartPlasticsPartModel = isSmartPlasticsPartModel;
const isSmartPlasticsType = (u) => {
    return (0, echain_shared_ts_utils_1.isValueInEnum)(echain_prisma_client_1.SmartPlasticsType, u);
};
exports.isSmartPlasticsType = isSmartPlasticsType;
const isECPSensor = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.ECPSensor);
};
exports.isECPSensor = isECPSensor;
const isECPDummy = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.ECPDummy);
};
exports.isECPDummy = isECPDummy;
const isECWSensor = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.ECWSensor);
};
exports.isECWSensor = isECWSensor;
const isECWBlackbox = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.ECWBlackbox);
};
exports.isECWBlackbox = isECWBlackbox;
const isIsenseSensorModule = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.IsenseModule);
};
exports.isIsenseSensorModule = isIsenseSensorModule;
const isIceeSensorModule = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.IceeModule);
};
exports.isIceeSensorModule = isIceeSensorModule;
const isSmsModule = (smartPlasticsPartModel) => {
    return smartPlasticsPartModel.articleSpecs.includes(echain_prisma_client_1.ArticleSpec.SMSModule);
};
exports.isSmsModule = isSmsModule;
//# sourceMappingURL=SmartPlasticsPartModel.js.map